import { apiAction } from '../../../../shared/store/apiAction';
import * as api from '../../../store/api';

import { fetchDataVisualizationsTypes } from './types';

export const fetchDataVisualizations = apiAction({
  types: fetchDataVisualizationsTypes,
  apiAction: api.fetchCustomReports,
});
